function calculatePercantageIncrease(currentVal, originalValue) {
    if (originalValue === 0) {
        return currentVal;
    }

    return ((currentVal - originalValue) / originalValue) * 100;
}

export default calculatePercantageIncrease;
